import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './reducers'
import rootSaga from './saga'

const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware]
const environment = process.env.NODE_ENV || 'development'
const compose = (middleware) => {
    return environment !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(middleware)
        : middleware
}

const store = createStore(
    rootReducer,
    compose(applyMiddleware(...middlewares))
)

sagaMiddleware.run(rootSaga)

export default store